import { render, staticRenderFns } from "./Newsdetails.vue?vue&type=template&id=31e05473&scoped=true&"
import script from "./Newsdetails.vue?vue&type=script&lang=js&"
export * from "./Newsdetails.vue?vue&type=script&lang=js&"
import style0 from "./Newsdetails.vue?vue&type=style&index=0&id=31e05473&prod&lang=css&"
import style1 from "./Newsdetails.vue?vue&type=style&index=1&id=31e05473&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e05473",
  null
  
)

export default component.exports